import React from 'react';
import { Tooltip, Skeleton } from '@mui/material';

import { 
  getDisplayName,
  getDescription as getSkillDescription
} from '../../../../../../constants/skillLevels';

import {
  SkillLevelDot,
  LevelName,
  SkillLevelOption,
  SkillLevelBar,
  HeaderSection,
  SkillName,
  SkillLevelContainer,
  TooltipContent,
  LoadingIndicator
} from './styles';

const SkillLevelSelector = ({ 
  selectedLevelId, 
  onLevelSelect, 
  skillName, 
  showHeader = true,
  customDescriptions = null,
  isLoadingDescriptions = false,
  skillLevels,
  loading = false
}) => {

  // Get the appropriate description for a competency level
  const getDescription = (levelId) => {
    // If we have custom descriptions and this level has one, use it
    if (customDescriptions && customDescriptions[levelId]) {
      return customDescriptions[levelId];
    }
    // Otherwise fall back to the default description
    return getSkillDescription(levelId, skillLevels);
  };

  return (
    <SkillLevelContainer>
      {showHeader && (
        <HeaderSection>
          <SkillName>
            {skillName}
          </SkillName>
        </HeaderSection>
      )}

      {isLoadingDescriptions && <LoadingIndicator />}

      <SkillLevelBar>
        {skillLevels.map((level) => (
          <Tooltip 
            key={level.levelId}
            title={
              isLoadingDescriptions ? (
                <Skeleton variant="text" width={200} height={20} />
              ) : (
                <TooltipContent>{getDescription(level.levelId)}</TooltipContent>
              )
            }
            arrow
            placement="right"
            enterDelay={500}
            leaveDelay={200}
            disabled={loading}
          >
            <SkillLevelOption
              $levelId={level.levelId}
              $skillLevels={skillLevels}
              $isSelected={selectedLevelId === level.levelId}
              onClick={() => !loading && onLevelSelect(level.levelId)}
              style={{ 
                cursor: loading ? 'wait' : 'pointer'
              }}
            >
              <SkillLevelDot $levelId={level.levelId} $skillLevels={skillLevels} $isSelected={selectedLevelId === level.levelId} />
              <LevelName $isSelected={selectedLevelId === level.levelId}>
                {getDisplayName(level.levelId, skillLevels)}
              </LevelName>
            </SkillLevelOption>
          </Tooltip>
        ))}
      </SkillLevelBar>
    </SkillLevelContainer>
  );
};

export default SkillLevelSelector; 